import url from './url';



export default url(({ featureSource = ':featureSource' }) => `/${featureSource}/create`);
